// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportsIncome_container__5sEfo {
  text-align: left;
}

.ReportsIncome_title__Zr-DA {
  font-size: 22px;
  font-weight: 600;
  color: #1d8752;
  margin-bottom: 6px;
}

.ReportsIncome_subtitle__mDxpI {
  color: #666;
  margin-bottom: 25px;
}

.ReportsIncome_box__Mlm\\+- {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 400px;
  background: #fff;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.ReportsIncome_button__YLI-i {
  margin-top: 8px;
  padding: 12px;
  background-color: #1d8752;
  color: white;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s ease;
}

.ReportsIncome_button__YLI-i:hover {
  background-color: #176c43;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ReportsPages/ReportsIncome.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  text-align: left;\n}\n\n.title {\n  font-size: 22px;\n  font-weight: 600;\n  color: #1d8752;\n  margin-bottom: 6px;\n}\n\n.subtitle {\n  color: #666;\n  margin-bottom: 25px;\n}\n\n.box {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-width: 400px;\n  background: #fff;\n  padding: 24px;\n  border-radius: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.button {\n  margin-top: 8px;\n  padding: 12px;\n  background-color: #1d8752;\n  color: white;\n  font-weight: 500;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.button:hover {\n  background-color: #176c43;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReportsIncome_container__5sEfo`,
	"title": `ReportsIncome_title__Zr-DA`,
	"subtitle": `ReportsIncome_subtitle__mDxpI`,
	"box": `ReportsIncome_box__Mlm+-`,
	"button": `ReportsIncome_button__YLI-i`
};
export default ___CSS_LOADER_EXPORT___;
